import { View, Text, styled, ScrollView } from 'tamagui'
import { Avatar } from '../../common'
import { users } from '@/mocks'

const Popover = styled(View, {
  backgroundColor: '$surfaceRaised',
  borderRadius: '$borderRadiusMd',
  borderWidth: 1,
  borderColor: '$borderDefault',
  padding: 12,
  minWidth: 180,
  maxWidth: 240,
  gap: 8,
})

const EmojiDisplay = styled(Text, {
  fontSize: 32,
  textAlign: 'center',
})

const Divider = styled(View, {
  height: 1,
  backgroundColor: '$borderDefault',
})

const UserRow = styled(View, {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  paddingVertical: 2,
})

const UserName = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 13,
  color: '$surfaceForeground',
})

interface ReactionPopoverProps {
  emoji: string
  userIds: string[]
}

export function ReactionPopover({ emoji, userIds }: ReactionPopoverProps) {
  return (
    <Popover>
      <EmojiDisplay>{emoji}</EmojiDisplay>
      <Divider />
      <ScrollView maxHeight={240} showsVerticalScrollIndicator={false}>
        <View gap={4}>
          {userIds.map((userId) => {
            const user = users[userId]
            if (!user) return null
            return (
              <UserRow key={userId}>
                <Avatar
                  name={user.displayName}
                  color={user.roleColor || '#2A3142'}
                  size="sm"
                  showStatus={false}
                />
                <UserName color={user.roleColor || '$surfaceForeground'}>
                  {user.displayName}
                </UserName>
              </UserRow>
            )
          })}
        </View>
      </ScrollView>
    </Popover>
  )
}
